module.exports = "<div id=\"extr-page\">\n<router-outlet></router-outlet>\n</div>\n"